import * as React from 'react';
import { Video } from '../../../../models';
import './style.css';

export interface CoachingInformationProps {
  video: Video;
}

export interface CoachingInformationState {
  /* empty*/
}

export interface CoachingInfoColumnElements {
  leftColumn: Array<JSX.Element>;
  rightColumn: Array<JSX.Element>;
}

export class CoachingInformation extends React.Component<
  CoachingInformationProps,
  CoachingInformationState
> {
  render() {
    const { video } = this.props;
    const { coachingInformation, coachingTips } = video;

    const combinedTips = coachingTips
      ? coachingTips.map(tip => tip.text || ``).join('\n')
      : '';

    const firstTipWithImage = coachingTips
      ? coachingTips.find(tip => !!tip.image)
      : undefined;

    return (
      <article className="coaching-information">
        <h2 className="coaching-information-header">Information Section</h2>
        <div className="coaching-information-content">
          <div className="coaching-information-column">
            <div className="coaching-information-details">
              {this.getParagraphs(coachingInformation || '')}
            </div>
          </div>
          <div className="coaching-information-column">
            <div className="coaching-information-tip">
              <div className="coaching-information-tip-content">
                <h3 className="coaching-information-tip-title">
                  Coaching Points
                </h3>
                {this.getParagraphs(combinedTips)}
              </div>
              <img
                className="coaching-information-tip-image"
                src={firstTipWithImage && firstTipWithImage.image}
                role="presentation"
              />
            </div>
          </div>
        </div>
      </article>
    );
  }

  private getParagraphs = (
    text: string,
    keyPrefix: string = 'coaching-info-paragraph'
  ): Array<JSX.Element> => {
    return text
      .split(/\r?\n/)
      .map((paragraph, index) => (
        <p key={`${keyPrefix}-${index}`}>{paragraph}</p>
      ));
  };
}

export default CoachingInformation;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoShow/CoachingInformation/index.tsx